let txc = {
    successTitle: 'Success!',
    successMessage:
        'Now that you’ve verfied your account you’ll have full-access to all of nuskin.com’s great features as you discover the best you!',
    successButton: 'Visit Homepage',
    successLink: '/content/nuskin/en_US/home.html',
    errorTitle: 'Oops!',
    errorMessage: 'This link has expired or has already been used.',
    errorButton: 'RETURN TO PROFILE',
    errorLink: '/content/nuskin/en_US/profile.html'
};

export const Translations = txc;
